import { DateTime } from 'luxon';

import { CompanyReportType } from '../../CompanyReport';
import { RecurringCompanyReport } from '../../RecurringCompanyReport';
import { Timezone } from '../../Time';
import { EDITED_REPORT_DELIVERY_HOUR } from '../EditedReportDeliveryHour';

export const GINNIE_MAE_TIMEZONE: Timezone = 'America/New_York' as const;
export const GINNIE_MAE_HOLIDAYS: DateTime[] = [
  DateTime.fromObject({ year: 2025, month: 1, day: 1 }),
  DateTime.fromObject({ year: 2025, month: 1, day: 20 }),
  DateTime.fromObject({ year: 2025, month: 2, day: 17 }),
  DateTime.fromObject({ year: 2025, month: 5, day: 26 }),
  DateTime.fromObject({ year: 2025, month: 6, day: 19 }),
  DateTime.fromObject({ year: 2025, month: 7, day: 4 }),
  DateTime.fromObject({ year: 2025, month: 9, day: 1 }),
  DateTime.fromObject({ year: 2025, month: 10, day: 13 }),
  DateTime.fromObject({ year: 2025, month: 11, day: 11 }),
  DateTime.fromObject({ year: 2025, month: 11, day: 27 }),
  DateTime.fromObject({ year: 2025, month: 12, day: 25 }),
] as const;

export const GINNIE_MAE_DEFAULT_RECURRING_REPORT_VALUES: Record<
  CompanyReportType.GINNIE_RFS | CompanyReportType.GINNIE_RFS_EDIT | CompanyReportType.GINNIE_PDS,
  Pick<RecurringCompanyReport, 'deliveryHour' | 'deliveryTimeZone' | 'title'> & { deliveryDay: number }
> = {
  GINNIE_RFS: {
    deliveryHour: 4,
    deliveryTimeZone: GINNIE_MAE_TIMEZONE,
    deliveryDay: 1,
    title: 'Ginnie Mae RFS',
  },
  GINNIE_RFS_EDIT: {
    deliveryHour: EDITED_REPORT_DELIVERY_HOUR,
    deliveryTimeZone: GINNIE_MAE_TIMEZONE,
    deliveryDay: 0,
    title: 'Ginnie Mae RFS (Edits)',
  },
  GINNIE_PDS: {
    deliveryHour: 4,
    deliveryTimeZone: GINNIE_MAE_TIMEZONE,
    deliveryDay: 1,
    title: 'Ginnie Mae PDS',
  },
} as const;
